import React from 'react';

const logoSrc = process.env.PUBLIC_URL + '/images/TrialView_Logo_RGB_Logo_White_Mid_Blue.png';

export default function Logo({ showText }) {
  return (
    <div className="logo" style={{ cursor: 'default' }}>
      {showText && (
        <a href="/" className="simple-text logo-normal" style={{ cursor: 'pointer' }}>
          <img src={logoSrc} alt="TrialView" style={{ maxHeight: '22px', width: 'auto' }} />
        </a>
      )}
    </div>
  );
}

Logo.propTypes = {};
Logo.defaultProps = { showText: true };
